import { LoaderCircle } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/lib/utils'

function Spinner({
  className,
  ...props
}: React.ComponentProps<typeof LoaderCircle>) {
  return (
    <LoaderCircle
      role='status'
      aria-label='Loading'
      className={cn('size-5 animate-spin text-ink-muted', className)}
      {...props}
    />
  )
}

export { Spinner }
